module.exports = __webpack_public_path__ + "img/icon-question.178c7824.svg";